import { render } from "./GamesList.vue?vue&type=template&id=5cb7c106&scoped=true"
import script from "./GamesList.vue?vue&type=script&lang=js"
export * from "./GamesList.vue?vue&type=script&lang=js"

import "./GamesList.vue?vue&type=style&index=0&id=5cb7c106&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb7c106"]])

export default __exports__